/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import Loader from '../loaders/loader'
import http from '../../Component/Interceptor/Interseptor'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import $ from 'jquery'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Sort from '../Pagination/Sort'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {Checkbox, message, Icon} from 'antd'
import AutoComplete from '../BaseComponent/autocomplete'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SearchProduct from '../BaseComponent/SearchProduct'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'

class ParcelLabel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      multiProvider: [],
      providerArr: [],
      providerId: '',
      providers: [],
      finalStocks: [],
      arrayOfStocks: [],
      sortBy: 'orderId_asc',
      date: moment(),
      defaultValueDate: true,
      items: [],
      driverId: ''
    }
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  async filter() {
    if (this.state.date === null) {
      message.error('تاریخ الزامی است')
    } else {
      await this.getReport()
    }
  }

  createFilter = () => {
    let filter = {
      stockProductIds: [],
      providerIds: []
    }
    let {date} = this.state
    let {finalStocks} = this.state
    let providerId = this.state.providerId

    if (providerId) {
      filter.providerIds = providerId
    }
    if (finalStocks.length !== 0) {
      filter.stockProductIds = finalStocks.join(',')
    }
    if (date) {
      filter.fromTime = this.epochFrom(date)
      filter.toTime = this.epochTo(date)
    }
    return filter
  }
  getReport = () => {
    let filter = this.createFilter()
    if (filter.fromTime === null && filter.toTime === null) {
      message.error('تاریخ الزامی است')
    } else if (filter.providerIds.length === 0) {
      message.error('فیلتر تامین کننده الزامی است')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/cart/products/jasper?fromTime=${filter.fromTime}&toTime=${
          filter.toTime
        }&stockProductIds=${filter.stockProductIds}&providerIds=${filter.providerIds}`
      )
    }
  }

  componentDidMount() {
    this.getProviders()
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
  }
  getProviders = () => {
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].providerId
            result[i]['label'] = '' + result[i].providerId + ' - ' + result[i].title
          }
          this.setState({
            providers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }
  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  handleDateChange = (date) => {
    this.setState({
      date
    })
  }

  render() {
    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>گزارش چیدمان بر اساس فاکتور</li>
          </ul>

          <div className="basketFilterComponent">
            <div className="filterInputs">
              <div className="formComponent">
                <label className="font-weight-bold">
                  تاریخ :<span className="requireFiled font-weight-bold">*</span>
                </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    inline
                    okLabel="تأیید"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    cancelLabel="لغو"
                    labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                    value={this.state.date}
                    id="date"
                    onChange={this.handleDateChange}
                    TextFieldComponent={this.date}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div className="formComponent selectComponent">
                <AutoComplete
                  label="تامین کننده"
                  api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                  textField="title"
                  valueField="providerId"
                  required
                  id="provider"
                  value={this.state.providerId}
                  setValue={(providerId) => this.setState({providerId})}
                />
                {/* <label>تامین کننده ها :</label>
                                    <Select
                                        value={this.state.multiProvider}
                                        onChange={this.handleChangeProvider}
                                        options={this.state.providers}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder=''
                                    /> */}
              </div>
            </div>
            <div>
              {this.state.providers.length ? (
                <SearchProduct
                  providers={this.state.providers}
                  getStocks={this.getStocks}
                  finalStocks={this.finalStocks}
                  providerId={this.state.providerId}
                />
              ) : null}
            </div>

            <div className="filterOption">
              <button className="confirmFilter" onClick={this.filter.bind(this)}>
                گزارش چیدمان بر اساس فاکتور
              </button>

              <p className="errorText mx-3" id="errorText" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ParcelLabel
